
import { Component, Vue } from 'vue-property-decorator'
import DetailContent from '@/views/product/DetailContent.vue'
@Component({
  components: { DetailContent }
})
export default class Detail extends Vue {
}
